import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoArrowForward } from "react-icons/io5";

import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/stuka.jpeg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";

export default function ServicesBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [bgIndex, setBgIndex] = useState(0);

  const banners = [banner1, banner2, banner3, banner4];
  const products = [
    {
      title: "Agrochemicals",
      description: "High-quality seeds and crop protection for better yields.",
      image: banner1,
      alt: "Agroseeds and Agrochemicals",
      subItem: "agroseeds",
    },
    {
      title: "High Iron & Zinc Beans",
      description: "Nutritious, high-yield beans rich in iron and zinc.",
      image: banner3,
      alt: "High Iron and Zinc Beans",
      subItem: "high_iron_zinc_beans",
    },
    {
      title: "STUKA M1",
      description: "Premium, disease-resistant seed with excellent yield.",
      image: banner2,
      alt: "Stuka M1",
      subItem: "stuka_m1",
    },
  ];

  useEffect(() => setReady(true), []);
  useEffect(() => {
    if (!ready) return;
    const interval = setInterval(() => {
      setBgIndex((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [ready]);

  if (!ready) return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  return (
    <section
      className="MainBodySection"
      style={{ position: "relative", overflow: "hidden" }}
    >
      <div
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        {banners.map((banner, i) => (
          <div
            key={i}
            style={{
              backgroundImage: `url(${banner})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "absolute",
              inset: 0,
              opacity: i === bgIndex ? 1 : 0,
              transition: "opacity 1.6s ease-in-out",
              filter: "brightness(0.32)",
            }}
          />
        ))}

        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            padding: "28px 16px",
          }}
        >
          <div className="container py-4 py-md-5">
            <div
              style={{
                borderRadius: "26px",
                border: "1px solid rgba(255,255,255,0.28)",
                background: "linear-gradient(145deg, rgba(255,255,255,0.16), rgba(255,255,255,0.08))",
                backdropFilter: "blur(6px)",
                boxShadow: "0 20px 45px rgba(0,0,0,0.20)",
                overflow: "hidden",
              }}
            >
              <div className="px-4 px-md-5 py-5 pb-4 text-center text-light">
                <h1 className="font-bold text-primary fs-1 mb-2">Explore Our Products</h1>
                <h6 className="mt-1 mb-0 text-light" style={{ opacity: 0.92 }}>
                  High-quality seeds, agrochemicals, and poultry supplies to boost farm productivity.
                </h6>
              </div>

              <div className="px-3 px-md-4 pb-4 pb-md-5">
                <div className="row g-3 g-md-4">
                  {products.map((product) => (
                    <div className="col-12 col-lg-4" key={product.title}>
                      <div
                        className="h-100"
                        onClick={() => appContext.navTo({ item: "services", subItem: product.subItem })}
                        style={{
                          cursor: "pointer",
                          borderRadius: "18px",
                          overflow: "hidden",
                          border: "1px solid rgba(255,255,255,0.26)",
                          background: "linear-gradient(180deg, rgba(10,10,10,0.30), rgba(10,10,10,0.52))",
                          transition: "transform .35s ease, box-shadow .35s ease",
                          boxShadow: "0 14px 26px rgba(0,0,0,0.18)",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-6px)";
                          e.currentTarget.style.boxShadow = "0 18px 34px rgba(0,0,0,0.24)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 14px 26px rgba(0,0,0,0.18)";
                        }}
                      >
                        <div style={{ height: "190px", overflow: "hidden" }}>
                          <img
                            src={product.image}
                            alt={product.alt}
                            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                          />
                        </div>
                        <div className="p-3 p-md-4 text-light">
                          <h5 className="font-bold mb-2">{product.title}</h5>
                          <p className="mb-0" style={{ opacity: 0.9 }}>
                            {product.description}
                          </p>
                          <div
                            className="d-flex justify-content-end align-items-center mt-3 pt-3"
                            style={{ borderTop: "1px solid rgba(255,255,255,0.22)" }}
                          >
                            <span
                              className="d-inline-flex align-items-center gap-2"
                              style={{
                                fontSize: "0.85rem",
                                letterSpacing: "0.06em",
                                opacity: 0.95,
                              }}
                            >
                              Explore
                              <span
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  borderRadius: "50%",
                                  border: "1px solid rgba(255,255,255,0.45)",
                                  background: "rgba(255,255,255,0.14)",
                                  display: "grid",
                                  placeItems: "center",
                                  fontSize: "15px",
                                }}
                              >
                                <IoArrowForward />
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
